import { createFileRoute } from '@tanstack/react-router';
import { LoaderIcon } from 'lucide-react';

/**
 * `/app` always redirects in the parent's `beforeLoad`; this index exists so the
 * bare path matches a leaf and the guard actually runs.
 */
function AppIndexFallback() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <LoaderIcon className="size-5 animate-spin text-ink-subtle" aria-label="Loading" />
    </div>
  );
}

export const Route = createFileRoute('/app/')({
  component: AppIndexFallback,
});
